var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className,style:({ height:_vm.height, width:_vm.width }),attrs:{"title":_vm.title,"id":_vm.id,"option":_vm.option}})
}
var staticRenderFns = []

export { render, staticRenderFns }